import { useSyncExternalStore } from "react";

function getMql(query: string): MediaQueryList | null {
  if (typeof window === "undefined" || !window.matchMedia) return null;
  return window.matchMedia(query);
}

function subscribeFactory(query: string) {
  return (callback: () => void) => {
    const mql = getMql(query);
    if (!mql) return () => {};
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", callback);
      return () => mql.removeEventListener("change", callback);
    }
    mql.addListener(callback);
    return () => mql.removeListener(callback);
  };
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    subscribeFactory(query),
    () => getMql(query)?.matches ?? false,
    () => false
  );
}
